import React from 'react';
import { Typography, Box } from '@mui/material';
import { ContentBox } from '../../libs/theme';
import { getText, useClipboard } from '../../libs/utils';
import { styled } from '@mui/material/styles';

const MyContentBox = styled(ContentBox)(({ theme }) => ({
  maxWidth: '680px',
  margin: '0 auto',
  textAlign: 'center',
  padding: '80px 100px',
  [theme.breakpoints.only('sm')]: {
    padding: '60px 80px'
  },
  [theme.breakpoints.only('xs')]: {
    padding: '40px 25px'
  },
}));

const NotFound = () => {
  const copyToClipboard = useClipboard();
  return (
    <MyContentBox>
      <img width={350} src="/404.jpg" alt="" />
      <Typography variant="h3" sx={{ margin: {xs: '20px 0 10px', sm: '35px 0 10px'}, fontWeight: 600 }}>{getText('pageNotFoundTitle')}</Typography>
      <Typography>{getText('pageNotFoundBody1')} <span onClick={copyToClipboard}><Typography variant='link' sx={{ textTransform: 'none', fontSize: '14px' }}>support@crypster.net</Typography></span> {getText('pageNotFoundBody2')}</Typography>
    </MyContentBox>
  )
}

export default NotFound